<template>
  <page-list
    :list="list"
    :columns="columns"
    :group-actions="showGroupActions ? groupActions : []"
    :showCheckbox="showGroupActions && showCheckbox" />
</template>

<script>
import * as R from 'ramda'
import ColumnsMixin from '../mixins/columns'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'

export default {
  name: 'VoucherManagerList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin],
  props: {
    id: String,
    resId: String,
    billId: String,
    getParams: {
      type: [Function, Object],
    },
    showCheckbox: {
      type: Boolean,
      default: true,
    },
    showGroupActions: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'billing_coupons',
        getParams: this.getParam,
        filterOptions: {
          status: {
            label: this.$t('scope.text_426'),
            dropdown: true,
            multiple: true,
            items: [
              { label: this.$t('scope.text_799'), key: 'valid' },
              { label: this.$t('scope.text_939'), key: 'redeemed' },
              { label: this.$t('scope.text_523'), key: 'cancelled' },
            ],
          },
        },
      }),
      groupActions: [
        {
          label: this.$t('scope.text_539'),
          action: () => {
            this.createDialog('CreateVoucherDialog', {
              title: this.$t('scope.text_940'),
              onManager: this.onManager,
              accountId: this.billId ? this.billId : '',
            })
          },
          meta: () => {
            return {
              buttonType: 'primary',
            }
          },
          hidden: (obj) => !this.isBackend,
        },
        {
          label: this.$t('dialog.cancel'),
          action: () => {
            this.$confirm({
              title: this.$t('dialog.cancel'),
              content: '确认取消所选优惠券？',
              onOk: async () => {
                await this.onManager('batchPerformAction', {
                  id: this.list.selectedItems.map(item => item.id),
                  managerArgs: {
                    action: 'cancel',
                  },
                })
                this.list.refresh()
              },
            })
          },
          meta: () => {
            const selected = this.list.selectedItems || []
            return {
              validate: selected.length > 0 && selected.every(item => item.status === 'valid'),
            }
          },
          hidden: (obj) => !this.isBackend,
        },
      ],
    }
  },
  created () {
    this.list.fetchData()
  },
  methods: {
    getParam () {
      const ret = { ...(R.is(Function, this.getParams) ? this.getParams() : this.getParams) }
      return ret
    },
  },
}
</script>
